import { SVGProps } from "react";

const Edit3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.1076 6.2137L5.92186 13.5427C5.65054 13.821 5.38797 14.3693 5.33545 14.7488L5.01161 17.4813C4.89783 18.4681 5.63303 19.1428 6.64831 18.9741L9.46658 18.5103C9.86043 18.4428 10.4118 18.1645 10.6832 17.8777L17.8689 10.5487C19.1117 9.28363 19.6719 7.84144 17.7376 6.07876C15.8121 4.33295 14.3504 4.94862 13.1076 6.2137Z"
      stroke="currentColor"
      strokeWidth={1.3}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 7C13.3156 9.14369 14.9596 10.7825 17 11"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Edit3;
